import Vue from 'vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import i18n from './lang/index'
import 'normalize.css/normalize.css'
import './permission'
import './styles/index.scss' // global css
import './styles/element-variables.scss'
import './assets/element.scss'
import messageLoading from './message-loading'
import Directives, { functionIndex } from './directives'
import LoadScript from '@yld/yun-utils-vue-plugin-load-script'
import App from './App.vue'
import YunIcon from '@yld/yun-icon'

import '@/icons' // icon

// 自定义指令
Vue.use(Directives)

Vue.use(YunIcon)

// 异步加载远程js
Vue.use(LoadScript)

Vue.use(Element, {
  size: 'small',
  zIndex: 3000
})

Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 }
Vue.prototype.$messageLoading = messageLoading

const serverConfig = require('../serverConfig.json')

window.serverConfig = serverConfig

Vue.prototype.$appId = serverConfig.appId // 应用Id

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  functionIndex,
  render: h => h(App)
})

